export default "__VITE_ASSET__ca2bbef7__"